import { BaseModel } from '../../../../../../core/_base/crud';

export class YeuCauBaoGia extends BaseModel {

    static thanhPhamId = 4;
    static category_path = "PBG";

    static optionsTinhTrang = [
        {
            id: 1,
            name: 'Đang soạn thảo',
            value: 'PBG_PHIEUMOI',
        },
        {
            id: 2,
            name: 'Đang thực hiện',
            value: 'PBG_DANGTHUCHIEN',
        },
        {
            id: 3,
            name: 'Chờ duyệt',
            value: 'PBG_CHODUYET',
        },
        {
            id: 4,
            name: 'Không duyệt',
            value: 'PBG_KHONGDUYET',
        },
        {
            id: 5,
            name: 'Hoàn tất',
            value: 'PBG_HOANTAT',
        },
        {
            id: 6,
            name: 'Đã hủy',
            value: 'PBG_DAHUY',
        },
        {
            id: 7,
            name: 'Chờ xem xét',
            value: 'PBG_CHOXEMXET',
        },
        {
            id: 8,
            name: 'Không đồng ý',
            value: 'PBG_KHONGDONGY',
        }
    ];

    Id: number
    IdKh: number
    MaKH: string
    TenKH: string
    GhiChu: string
    NguoiTao: number
    TenNguoiTao: string
    NgayTao: string
    SoPhieu: string
    NgayYeuCauBg: string
    TinhTrang: string
    TenTinhTrang: string
    listYeuCauBaoGiaCt: YeuCauBaoGiaCt[]
    listYeuCauBaoGiaLsThaoTac: YeuCauBaoGiaLsThaoTac[]
    numChoDuyet: number
    numDuocDuyet: number
    numKhongDuocDuyet: number
    IsEnable_Duyet: boolean
    IsVisible_Duyet: boolean
    BusinessModel: string
    clear() {
        this.Id = 0;
        this.IdKh = 0;
        this.MaKH = '';
        this.TenKH = '';
        this.GhiChu = '';
        this.NguoiTao = 0;
        this.TenNguoiTao = '';
        this.NgayTao = '';
        this.SoPhieu = '';
        this.NgayYeuCauBg = '';
        this.TinhTrang = '';
        this.TenTinhTrang = '';
        this.listYeuCauBaoGiaCt = [];
        this.listYeuCauBaoGiaLsThaoTac = [];
        this.numChoDuyet = 0;
        this.numDuocDuyet = 0;
        this.numKhongDuocDuyet = 0;
        this.IsEnable_Duyet = false;
        this.IsVisible_Duyet = false;
        this.BusinessModel = ""
    }
    copy(item: YeuCauBaoGia) {
        this.Id = item.Id;
        this.IdKh = item.IdKh;
        this.MaKH = item.MaKH;
        this.TenKH = item.TenKH;
        this.GhiChu = item.GhiChu;
        this.NguoiTao = item.NguoiTao;
        this.TenNguoiTao = item.TenNguoiTao;
        this.NgayTao = item.NgayTao;
        this.SoPhieu = item.SoPhieu;
        this.NgayYeuCauBg = item.NgayYeuCauBg;
        this.TinhTrang = item.TinhTrang;
        this.TenTinhTrang = item.TenTinhTrang;
        this.listYeuCauBaoGiaCt = item.listYeuCauBaoGiaCt;
        this.listYeuCauBaoGiaLsThaoTac = item.listYeuCauBaoGiaLsThaoTac;
        this.numChoDuyet = item.numChoDuyet;
        this.numDuocDuyet = item.numDuocDuyet;
        this.numKhongDuocDuyet = item.numKhongDuocDuyet;
        this.IsEnable_Duyet = item.IsEnable_Duyet;
        this.IsVisible_Duyet = item.IsVisible_Duyet;
        this.BusinessModel = item.BusinessModel;
    }
}
export class YeuCauBaoGiaCt extends BaseModel {

    static category_path = "PBG_DETAIL";
    static DEFAULT_NUMBER_VALUE = "0,00";
    static DEFAULT_NUMBER_VALUE_NUMBER = "0.00";
    static optionTrangThaiDetail = [
        {
            id: 1,
            name: 'Đang soạn thảo',
            value: 'PBG_DETAIL_PHIEUMOI',
        },
        {
            id: 2,
            name: 'Không duyệt báo giá',
            value: 'PBG_DETAIL_KODUYETBAOGIA',
        },
        {
            id: 3,
            name: 'Chờ duyệt',
            value: 'PBG_DETAIL_CHODUYETBAOGIA',
        },
        {
            id: 4,
            name: 'Đã duyệt báo giá',
            value: 'PBG_DETAIL_DADUYETBAOGIA',
        },
        {
            id: 5,
            name: 'Chờ báo giá lại',
            value: 'PBG_DETAIL_BAOGIALAI',
        },
        {
            id: 6,
            name: 'Chờ xem xét',
            value: 'PBG_DETAIL_CHOXEMXETBAOGIA',
        },
        {
            id: 7,
            name: 'Không đồng ý báo giá',
            value: 'PBG_DETAIL_KHONGDONGYBAOGIA',
        }
    ]

    Id: number
    YeuCauBaoGiaId: number
    HangHoaId: number
    MaHH: string
    TenHH: string
    QuyCach: string
    SoLuong: number
    Dvt: number
    DonViTinh: string
    GhiChu: string
    TienTeId: number
    TienTeTen: string
    TenSanPham: string
    GiaGanNhat: number
    GiaKhachHangMongMuon: number
    TrangThai: string
    SanPhamMoi: boolean
    GiaMin: number
    GiaMax: number
    IsEnable_Duyet: boolean
    IsVisible_Duyet: boolean
    isDone: boolean
    idDatHangCT: number
    SLCoPO: number
    SLTuDo: number
    ThoiHanGiuGia: number
    LapYeuCauDuyetGia: number
    KLSaiSo: number
    ThoiGianDuyet : string
    clear() {
        this.Id = 0;
        this.YeuCauBaoGiaId = 0;
        this.HangHoaId = 0;
        this.MaHH = '';
        this.TenHH = '';
        this.QuyCach = '';
        this.SoLuong = 0;
        this.Dvt = 0;
        this.DonViTinh = '';
        this.GhiChu = '';
        this.TienTeId = 0;
        this.TienTeTen = '';
        this.TenSanPham = '';
        this.GiaGanNhat = 0;
        this.GiaKhachHangMongMuon = 0;
        this.TrangThai = '';
        this.SanPhamMoi = false;
        this.GiaMin = 0;
        this.GiaMax = 0;
        this.IsEnable_Duyet = false;
        this.IsVisible_Duyet = false;
        this.isDone = false;
        this.idDatHangCT = 0;
        this.SLCoPO = 0;
        this.SLTuDo = 0;
        this.ThoiHanGiuGia = 0;
        this.LapYeuCauDuyetGia = 0;
        this.KLSaiSo = null;
        this.ThoiGianDuyet = ''
    }
    copy(item: YeuCauBaoGiaCt) {
        this.Id = item.Id;
        this.YeuCauBaoGiaId = item.YeuCauBaoGiaId;
        this.HangHoaId = item.HangHoaId;
        this.MaHH = item.MaHH;
        this.TenHH = item.TenHH;
        this.QuyCach = item.QuyCach;
        this.SoLuong = item.SoLuong;
        this.Dvt = item.Dvt;
        this.DonViTinh = item.DonViTinh;
        this.GhiChu = item.GhiChu;
        this.TienTeId = item.TienTeId;
        this.TienTeTen = item.TienTeTen;
        this.TenSanPham = item.TenSanPham;
        this.GiaGanNhat = item.GiaGanNhat;
        this.GiaKhachHangMongMuon = item.GiaKhachHangMongMuon;
        this.TrangThai = item.TrangThai;
        this.SanPhamMoi = item.SanPhamMoi;
        this.GiaMin = item.GiaMin;
        this.GiaMax = item.GiaMax;
        this.IsEnable_Duyet = item.IsEnable_Duyet;
        this.IsVisible_Duyet = item.IsVisible_Duyet;
        this.isDone = item.isDone;
        this.idDatHangCT = item.idDatHangCT;
        this.SLCoPO = item.SLCoPO;
        this.SLTuDo = item.SLTuDo;
        this.ThoiHanGiuGia = item.ThoiHanGiuGia;
        this.LapYeuCauDuyetGia = item.LapYeuCauDuyetGia;
        this.KLSaiSo = item.KLSaiSo
        this.ThoiGianDuyet = item.ThoiGianDuyet;
    }
}
export class YeuCauBaoGiaLsThaoTac extends BaseModel {
    Id: number
    YeuCauBaoGiaId: number
    NguoiThaoTac: number
    TenNguoiThaoTac: string
    NgayThaoTac: string
    LoaiThaoTac: string
    GhiChu: string
    NoiDung: string
    YeuCauBaoGia_Ct_Id: number

    clear() {
        this.Id = 0;
        this.YeuCauBaoGiaId = 0;
        this.NguoiThaoTac = 0;
        this.TenNguoiThaoTac = '';
        this.NgayThaoTac = '';
        this.LoaiThaoTac = '';
        this.GhiChu = '';
        this.NoiDung = '';
        this.YeuCauBaoGia_Ct_Id = 0;
    }

    copy(item: YeuCauBaoGiaLsThaoTac) {
        this.Id = item.Id;
        this.YeuCauBaoGiaId = item.YeuCauBaoGiaId;
        this.NguoiThaoTac = item.NguoiThaoTac;
        this.TenNguoiThaoTac = item.TenNguoiThaoTac;
        this.NgayThaoTac = item.NgayThaoTac;
        this.LoaiThaoTac = item.LoaiThaoTac;
        this.GhiChu = item.GhiChu;
        this.NoiDung = item.NoiDung;
        this.YeuCauBaoGia_Ct_Id = item.YeuCauBaoGia_Ct_Id;
    }
}
export class HangBanKH extends BaseModel {
    Id: number
    HangHoaId: number
    MaHH: string
    TenHH: string
    Dvt: number
    DonViTinh: string
    IdKh: number
    MaKH: string
    TenKH: string
    SoPhieu: string
    SoLuong: number
    DonGia: number
    NgayTao: string
    GiaMin: number
    GiaMax: number
    GiaTB: number
    datHangId: number

    clear() {
        this.Id = 0;
        this.HangHoaId = 0;
        this.MaHH = '';
        this.TenHH = '';
        this.Dvt = 0;
        this.DonViTinh = '';
        this.IdKh = 0;
        this.MaKH = '';
        this.TenKH = '';
        this.SoPhieu = '';
        this.SoLuong = 0;
        this.DonGia = 0;
        this.NgayTao = '';
        this.GiaMin = 0;
        this.GiaMax = 0;
        this.GiaTB = 0;
        this.datHangId = 0;
    }

    copy(item: HangBanKH) {
        this.Id = item.Id;
        this.HangHoaId = item.HangHoaId;
        this.MaHH = item.MaHH;
        this.TenHH = item.TenHH;
        this.Dvt = item.Dvt;
        this.DonViTinh = item.DonViTinh;
        this.IdKh = item.IdKh;
        this.MaKH = item.MaKH;
        this.TenKH = item.TenKH;
        this.SoPhieu = item.SoPhieu;
        this.SoLuong = item.SoLuong;
        this.DonGia = item.DonGia;
        this.NgayTao = item.NgayTao;
        this.GiaMin = item.GiaMin;
        this.GiaMax = item.GiaMax;
        this.GiaTB = item.GiaTB;
        this.datHangId = item.datHangId;
    }

}
export const YeuCauBaoGiaConfig = {
    B2B: {
        PARAM_REQUEST_PRICE: "kd-yeu-cau-bao-gia",
        TITLE_REQUEST_PRICE: "Danh sách yêu cầu báo giá B2B",
        BUSINESS_TYPE: "B2B"
    },
    B2C: {
        PARAM_REQUEST_PRICE: "kd-yeu-cau-bao-gia-b2c",
        TITLE_REQUEST_PRICE: "Danh sách yêu cầu báo giá B2C",
        BUSINESS_TYPE: "B2C"
    }
};
